import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { FormControl, FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ApiService } from "src/app/core/services/api.service";
import { NotificationService } from "src/app/core/services/notification.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ApiConstants } from "src/app/core/constants/api-path.constants";
import { Subject } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { PreviewDialogComponent } from "./preview-dialog/preview-dialog.component";
import { ServiceLocalStorage } from "src/app/core/services/local-storage.service";

@Component({
  selector: "app-manage-master-route",
  templateUrl: "./manage-master-route.component.html",
  styleUrls: ["./manage-master-route.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ManageMasterRouteComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public mLocation = new FormControl("", Validators.required);
  public mSite = new FormControl("", Validators.required);
  public mShift = new FormControl("", Validators.required);
  public mRouteType = new FormControl("", Validators.required);

  searchEmpTxt: any = '';
  cities: any = [];
  sites: any = [];
  shifts = [];
  exceptionEmps: any = [];
  tripsList: any[] = [];
  masterRouteData: any;
  typeFlag: boolean = false;
  userSearchResult: any = [];
  userNotFound: boolean;
  types: any = [
    { value: "MASTER_ROUTING", view: "ROUTING" },
    { value: "MASTER_IR", view: "IR" }
  ];
  activeTabId = 1;
  _mCurrentUserData: any;

  constructor(
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    public readonly dialog: MatDialog,
    private ngxLoader: NgxUiLoaderService,
    private fb: FormBuilder,
    private cd: ChangeDetectorRef,
    public readonly serviceLocalStorage: ServiceLocalStorage,
  ) {
  }

  ngOnInit() {
    this._mCurrentUserData = this.serviceLocalStorage.getUserObject();
    this.loadCities();
    this._mFormGroup = this.fb.group({
      location: this.mLocation,
      site: this.mSite,
      shift: this.mShift,
      routeType: this.mRouteType
    });
  }

  loadCities() {
  this.apiService.doGetRequestWithResponse(
    ApiConstants.getserchlocationlist,
    success => {
      if (success.status === 200) {
        this.cities = success.body || [];
        this.cd.markForCheck();

        const userLocationId =
          this._mCurrentUserData?.userInfoDetails?.site?.location?.locationId;

        const selectedLocationId =
          userLocationId &&
          this.cities.some(c =>
            (c.locationId || c.id) === userLocationId
          )
            ? userLocationId
            : this.cities[0]?.locationId || this.cities[0]?.id;

        if (selectedLocationId) {
          this.mLocation.setValue(selectedLocationId);
          this.getSitesByCityId();
        }
      } else {
        this.cities = [];
      }
    },
    error => {
      this.notifyService.showError(error, null);
    }
  );
}

  getSitesByCityId() {
  const endpoint = `${ApiConstants.getserchsitelist}${this.mLocation.value}`;

  this.apiService.doGetRequestWithResponse(
    endpoint,
    success => {
      if (success.status === 200) {
        this.sites = success.body || [];
        this.mSite.enable();
        this.cd.markForCheck();

        const userSiteId =
          this._mCurrentUserData?.userInfoDetails?.site?.siteId;

        const selectedSiteId =
          userSiteId &&
          this.sites.some(s => s.siteId === userSiteId)
            ? userSiteId
            : this.sites[0]?.siteId;

        if (selectedSiteId) {
          this.mSite.setValue(selectedSiteId);
          this.getShiftTime();
        }
      } else {
        this.sites = [];
        this.notifyService.showInfo('No Sites Found!', null);
      }
    },
    error => {}
  );
}

  getShiftTime() {
    const endpoint = `${ApiConstants.getShiftTimesListBySiteId}?siteId=${this.mSite.value}&shiftType=General`;
    this.apiService.doGetRequestWithResponse(endpoint,
      success => {
        if (success.status === 200) {
          this.mShift.enable();
          this.shifts = success.body;

          // Prefill Shift with first available when shifts load
          if (!this.mShift.value && this.shifts && this.shifts.length > 0) {
            const firstShift = this.shifts[0];
            this.mShift.setValue(firstShift.shiftTimeId || firstShift.shiftId || firstShift.id || firstShift.name || firstShift);
          }

          // Prefill Route Type with first option if not already set
          if (!this.mRouteType.value && this.types && this.types.length > 0) {
            this.mRouteType.setValue(this.types[0].value);
          }

          // Ensure view updates with newly set values
          this.cd.markForCheck();
        } else {
          this.shifts = [];
          this.notifyService.showInfo("No Shifts Found!", null);
        }
      },
      error => { }
    );
  }

  getSerchUser($event) {
    const searchKey = $event.target.value;
    if (searchKey.length < 3) return;
    this.apiService.doGetRequestWithResponse(ApiConstants.getexceptionemployeesearch + '?searchkey=' +
      searchKey,
      success => {
        this.userSearchResult = success.body;
        if (this.userSearchResult == null) {
          this.userNotFound = true;
        } else {
          this.userNotFound = false;
        }
        this.cd.markForCheck();
      },
      error => {
        console.error("Error fetching user search results", error);
      }
    );
  }

  setLandmark(user, type) {
    const selectedUser = user.userInfoDetails;
    selectedUser.landmark = type === "P" ? user.userInfoDetails.pickUpDrop : user.userInfoDetails.homePoint;
    this.exceptionEmps = this.exceptionEmps.filter(emp =>
      emp.landmark.id !== selectedUser.landmark.id
    );

    selectedUser.status = null;
    this.exceptionEmps.push(selectedUser);
    this.cd.markForCheck();
  }

  // userSearchSubmit(user) {
  //   this.cd.markForCheck();
  //   this.tripsList.forEach((trips, i) => {
  //     trips.tripDetails.tripUsers.forEach((users, j) => {
  //       if (!users.tripUser) {
  //         if (users.employeeId === user.userInfoDetails.employeeId) {
  //           this.exceptionEmps.splice(this.exceptionEmps.indexOf(user), 1);
  //           this.notifyService.showError("User already exist in list!", null);
  //         }
  //       } else {
  //         if (
  //           users.tripUser.userInfoDetails.employeeId ===
  //           user.userInfoDetails.employeeId
  //         ) {
  //           this.exceptionEmps.splice(this.exceptionEmps.indexOf(user), 1);
  //           this.notifyService.showError("User already exist in list!", null);
  //         }
  //       }
  //     });
  //   });
  // }

  userSearchSubmit(user) {
    const userEmployeeId = user.userInfoDetails.employeeId;
    const userExists = this.tripsList.some(trips =>
      trips.tripDetails.tripUsers.some(users => {
        const existingEmployeeId = users.tripUser
          ? users.tripUser.userInfoDetails.employeeId
          : users.employeeId;
        return existingEmployeeId === userEmployeeId;
      })
    );

    if (userExists) {
      this.exceptionEmps = this.exceptionEmps.filter(emp => emp !== user);
      this.notifyService.showWarning("User already exist in list!", null);
    }
    this.cd.markForCheck();
  }

  // getallmasterroute() {
  //   if (this.mLocation.valid) {
  //     if (this.mSite.valid) {
  //       if (this.mShift.valid) {
  //         if (this.mRouteType.valid) {
  //           this.typeFlag = false;
  //           this.apiService.doGetRequestWithResponse(ApiConstants.getallmasterroute + '?shiftid=' +
  //             this.mShift.value + '&siteid=' +
  //             this.mSite.value + '&type=' +
  //             this.mRouteType.value,
  //             success => {
  //               if (success.status == 200) {
  //                 this.tripsList = success.body.tripVendorDetails;
  //                 this.masterRouteData = success.body;
  //                 if (this.mRouteType.value == "MASTER_IR") {
  //                   this.typeFlag = true;
  //                 }
  //               } else {
  //                 this.tripsList = [];
  //                 this.notifyService.showInfo(
  //                   "No Master route Found!.",
  //                   null
  //                 );
  //               }
  //               this.cd.markForCheck();
  //             },
  //             error => {
  //             }
  //           );
  //         } else {
  //           this.notifyService.showInfo("Please select route type.", null);
  //         }
  //       } else {
  //         this.notifyService.showInfo("Please select shift time.", null);
  //       }
  //     } else {
  //       this.notifyService.showInfo("Please select site.", null);
  //     }
  //   } else {
  //     this.notifyService.showInfo("Please select the city.", null);
  //   }
  //   this.cd.markForCheck();
  // }

  getallmasterroute() {
    if (!this.mLocation.valid) {
      this.notifyService.showWarning("Please select the city.", null);
      return;
    }
    if (!this.mSite.valid) {
      this.notifyService.showWarning("Please select site.", null);
      return;
    }
    if (!this.mShift.valid) {
      this.notifyService.showWarning("Please select shift time.", null);
      return;
    }
    if (!this.mRouteType.valid) {
      this.notifyService.showWarning("Please select route type.", null);
      return;
    }
    this.typeFlag = false;
    this.ngxLoader.start();
    const endpoint = `${ApiConstants.getallmasterroute}?shiftid=${this.mShift.value}&siteid=${this.mSite.value}&type=${this.mRouteType.value}`;
    this.apiService.doGetRequestWithResponse(endpoint,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.tripsList = success.body.tripVendorDetails;
          this.masterRouteData = success.body;
          this.typeFlag = this.mRouteType.value === "MASTER_IR";
        } else {
          this.tripsList = [];
          this.notifyService.showInfo("No Master route Found!.", null);
        }
        this.cd.markForCheck();
      },
      error => { this.ngxLoader.stop(); }
    );
  }

  // addTrip() {
  //   let tripCode = this.tripsList.length;
  //   let newTrip = {
  //     id: null,
  //     tripDetails: {
  //       tripUsers: [],
  //       tripId: null,
  //       tripCode: tripCode + 1,
  //       tripVendorAssign: null,
  //       site: this.tripsList[0].tripDetails.site,
  //       shift: this.tripsList[0].tripDetails.shift,
  //       escortStatus: null,
  //       tripDate: null,
  //       tripDistance: null,
  //       tripTravelTime: null,
  //       createDateTime: null,
  //       modifiedDate: null,
  //       tripstatus: null,
  //       zone: this.tripsList[0].tripDetails.zone,
  //       generatestatus: 1
  //     },
  //     vendorMaster: null,
  //     status: "Active",
  //     createDateTime: null,
  //     modifiedDate: null,
  //     vehicle: null,
  //     vehicleType: null,
  //     driver: null,
  //     onTimeStatus: null,
  //     adminComments: null,
  //     vendorComments: null,
  //     deviceImei: null,
  //     startDateTime: null,
  //     stopDateTime: null,
  //     downloadStatus: null,
  //     timeElapsed: null,
  //     distanceCovered: null,
  //     escort: null,
  //     escortBoardedStatus: null,
  //     escortBoardedDataTime: null,
  //     escortBoardedLatitude: null,
  //     escortBoardedLongitude: null,
  //     DeviceTripStatus: null,
  //     forceStop: null,
  //     deviceTripStatus: null
  //   };
  //   this.tripsList.splice(0, 0, newTrip);
  //   this.cd.markForCheck();
  // }

  addTrip() {
    const newTrip = {
      id: null,
      driver: null,
      vehicle: null,
      vehicleType: null,
      vendorMaster: null,
      tripDetails: {
        tripUsers: [],
        tripId: null,
        tripCode: this.tripsList.length + 1,
        site: this.tripsList[0].tripDetails.site,
        shift: this.tripsList[0].tripDetails.shift,
        escortStatus: null,
        tripDate: null,
        tripDistance: null,
        tripTravelTime: null,
        tripstatus: null,
        zone: null,
        generatestatus: null,
        routingType: null,
        routeName: null,
        masterRouteName: null
      }
    };

    this.tripsList.unshift(newTrip);
    this.cd.markForCheck();
  }

  deleteView(index) {
    this.tripsList.splice(index, 1);
    this.cd.markForCheck();
  }

  // previewDialog(tripDetails) {
  //   this.tripsList.forEach((element, i) => {
  //     let tripOrder = 1;
  //     element.tripDetails.tripUsers.forEach((element, j) => {
  //       this.tripsList[i].tripDetails.tripUsers[j].routedOrder = tripOrder;
  //       tripOrder++;
  //     });
  //   });
  //   if (tripDetails.tripDetails.tripUsers.length > 0) {
  //     let dialogRef = this.dialog.open(PreviewDialogComponent, {
  //       width: "700px",
  //       height: "500px",
  //       data: tripDetails,
  //       disableClose: true
  //     });
  //     dialogRef.afterClosed().subscribe(result => {
  //       if (result) {
  //       }
  //     });
  //   } else {
  //     this.notifyService.showInfo("No landmark Found!.", null);
  //   }
  // }

  previewDialog(tripDetails) {
    this.tripsList.forEach(trip => {
      trip.tripDetails.tripUsers.forEach((user, index) => {
        user.routedOrder = index + 1;
      });
    });

    if (!tripDetails.tripDetails.tripUsers.length) {
      this.notifyService.showInfo("No landmark found!.", null);
      return;
    }

    const dialogRef = this.dialog.open(PreviewDialogComponent, {
      width: "700px",
      height: "500px",
      data: tripDetails,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  // deleteComb(tripDetails) {
  //   let idList = [];
  //   idList.push(tripDetails.id);
  //   this.apiService.doPostRequestWithResponse(ApiConstants.deletemasterroute + '?routeType=' +
  //     this.mRouteType.value,
  //     idList,
  //     success => {
  //       if (success) {
  //         this.notifyService.showSuccess("Updated successfully", null);
  //         this.getallmasterroute();
  //       }
  //     },
  //     error => {

  //     }
  //   );
  // }

  deleteComb(tripDetails) {
    const endpoint = `${ApiConstants.deletemasterroute}?routeType=${this.mRouteType.value}`;
    this.apiService.doPostRequestWithResponse(endpoint, [tripDetails.id],
      success => {
        if (success) {
          this.notifyService.showSuccess(success.body.message, null);
          this.getallmasterroute();
        }
      },
      error => { }
    );
  }

  dragStarted(trip, index) {
    this.cd.markForCheck();
    // this.toDropTrip = trip;
    // this._tripIndex = index;
  }

  dragEndTrips(event, trip) { }

  onItemDrop(trip, user) {
    this.cd.reattach();
    this.tripsList.forEach(trip => {
      trip.tripDetails.tripUsers.forEach((user, index) => {
        user.routedOrder = index + 1;
      });
    });
  }

  // save() {
  //   this.masterRouteData.tripVendorDetails = [];
  //   this.tripsList.forEach(element => {
  //     if (element.tripDetails.tripUsers.length > 0) {
  //       this.masterRouteData.tripVendorDetails.push(element);
  //     }
  //   });
  //   this.apiService.doPostRequestWithResponse(ApiConstants.saveallmasterroute,
  //     this.masterRouteData,
  //     success => {
  //       if (success) {

  //         this.notifyService.showSuccess("Saved successfully", null);
  //       }
  //     },
  //     error => {

  //       this.notifyService.showError("Saved failed", null);
  //     }
  //   );
  // }

  save() {
    this.masterRouteData.tripVendorDetails = this.tripsList.filter(
      trip => trip.tripDetails.tripUsers.length > 0
    );

    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      ApiConstants.saveallmasterroute,
      this.masterRouteData,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.notifyService.showSuccess(success.body.message, null);
        }
      },
      error => {
        this.ngxLoader.stop();
        console.error("Error saving master route data", error);
        this.notifyService.showError("Failed to save", null);
      }
    );
  }

  // saveSingleTrip(trip) {
  //   this.masterRouteData.tripVendorDetails = [];
  //   if (trip.tripDetails.tripUsers.length > 0) {
  //     this.masterRouteData.tripVendorDetails.push(trip);
  //   }
  //   this.apiService.doPostRequestWithResponse(ApiConstants.saveallmasterroute,
  //     this.masterRouteData,
  //     success => {
  //       if (success) {
  //         this.notifyService.showSuccess("Saved successfully", null);
  //       }
  //     },
  //     error => {
  //       this.notifyService.showSuccess("Failed to save", null);
  //     }
  //   );
  // }

  saveSingleTrip(trip) {
    this.masterRouteData.tripVendorDetails = trip.tripDetails.tripUsers.length > 0 ? [trip] : [];
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(
      ApiConstants.saveallmasterroute,
      this.masterRouteData,
      success => {
        this.ngxLoader.stop();
        if (success.status === 200) {
          this.notifyService.showSuccess(success.body.message, null);
        }
      },
      error => {
        this.ngxLoader.stop();
        console.error("Error saving single trip", error);
      }
    );
  }
}
